import { APP_BASE_HREF } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { BoxContainerModule } from '@rig/ng-containers';
import {
  CARD_ASSET_REGISTRY,
  CardArtModule,
  CTATextModule,
  ICON_ASSET_REGISTRY,
  IconButtonModule,
  ListModule,
  LOGO_ASSET_REGISTRY,
  LogoModule,
  MediaModule,
  RBCCoreComponentsModule,
  SelectableCardModule,
  SelectableDirectiveModule,
  SingleSelectGroupModule,
  TypographyModule,
} from "@rig/ng-core-components";
import { from, Observable } from "rxjs";

import { environment } from "../environments/environment";
import { AppComponent } from "./app.component";
import { PreQualificationComponent } from "./components/pre-qualification/pre-qualification.component";
import { StaticFooterComponent } from "./components/static-footer/static-footer.component";
import { StaticHeaderComponent } from "./components/static-header/static-header.component";
import { RiamComponent } from "./pages/riam/riam.component";
import { StepPreQualificationComponent } from "./pages/step-pre-qualification/step-pre-qualification.component";
import { AssetUrlModule } from "./pipes/asset-url/asset-url.module";
import { RoutesModule } from "./routes/routes.module";
import { CREDIT_CARDS_BASE_URL } from "./tokens/credit-cards-base-url.token";

export function TranslateLoaderFactory() {
  return new (class extends TranslateLoader {
    getTranslation(lang: string): Observable<any> {
      return lang.toLowerCase().startsWith("en") ? from(import("./i18n/en.json")) : from(import("./i18n/fr.json"));
    }
  })();
}

export const ENV_NAME = {
  PROD: "production",
  LOCAL: "local",
  UAT: "uat"
};

@NgModule({
  declarations: [
    AppComponent,
    StaticHeaderComponent,
    StaticFooterComponent,
    StepPreQualificationComponent,
    PreQualificationComponent,
    RiamComponent
  ],
  imports: [
    BoxContainerModule,
    IconButtonModule,
    BrowserModule,
    RoutesModule,
    RBCCoreComponentsModule,
    LogoModule,
    CardArtModule,
    TypographyModule,
    CTATextModule,
    FormsModule,
    SelectableDirectiveModule,
    SelectableCardModule,
    SingleSelectGroupModule,
    ListModule,
    ReactiveFormsModule,
    HttpClientModule,
    MediaModule.forRoot(environment.rigAssetCdn),
    AssetUrlModule.forRoot(`${environment.staticsConfig.appPath}/assets`),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: TranslateLoaderFactory
      }
    }),
  ],
  providers: [
    {
      provide: APP_BASE_HREF,
      useValue: environment.links.ftr_intro.base_href
    },
    {
      provide: CREDIT_CARDS_BASE_URL,
      useValue: environment.creditCardsBaseUrl
    },
    {
      provide: ICON_ASSET_REGISTRY,
      useValue: [
        {
          scope: "local",
          url: "./assets"
        },
        {
          scope: "rbc",
          default: true,
          manifest: "https://rig-assets.apps.cloud.saifg.rbc.com/icons/rbc"
        }
      ]
    },
    {
      provide: LOGO_ASSET_REGISTRY,
      useValue: [
        {
          scope: "rbc",
          default: true,
          manifest: "https://rig-assets.apps.cloud.saifg.rbc.com/logos/rbc"
        }
      ]
    },
    {
      provide: CARD_ASSET_REGISTRY,
      useValue: [
        {
          scope: "rbc",
          default: true,
          manifest: `${environment.rigAssetCdn}/card-art/rbc`
        }
      ]
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
